var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreasing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8274_78)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5671 65C45.322 64.9854 46.9999 64.3495 48.2371 63.23L62.5808 50.36C63.2021 49.7979 63.5508 49.0376 63.5508 48.245C63.5508 47.4524 63.2021 46.6921 62.5808 46.13C62.2707 45.8488 61.9017 45.6256 61.4952 45.4733C61.0888 45.321 60.6528 45.2426 60.2124 45.2426C59.772 45.2426 59.336 45.321 58.9296 45.4733C58.5231 45.6256 58.1541 45.8488 57.844 46.13L46.9028 56L46.9028 26C46.9028 25.2044 46.5514 24.4413 45.9258 23.8787C45.3002 23.3161 44.4518 23 43.5671 23C42.6824 23 41.8339 23.3161 41.2084 23.8787C40.5828 24.4413 40.2313 25.2044 40.2313 26L40.2313 56L29.2568 46.13C28.6331 45.5651 27.7854 45.2461 26.9002 45.2433C26.015 45.2405 25.1648 45.5541 24.5367 46.115C23.9086 46.6759 23.5539 47.4383 23.5508 48.2344C23.5477 49.0305 23.8963 49.7951 24.52 50.36L38.8637 63.23C40.1091 64.3568 41.8005 64.9933 43.5671 65Z",
    fill: "#D6D6D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8274_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreasing);
export default __webpack_public_path__ + "static/media/decreasing.020536e322014b3fb08059676ac14a71.svg";
export { ForwardRef as ReactComponent };